export const FETCH_ADMIN_COIN_VALUE_EDIT_REQUEST = "FETCH_ADMIN_COIN_VALUE_EDIT_REQUEST";
export const FETCH_ADMIN_COIN_VALUE_EDIT_SUCCESS = "FETCH_ADMIN_COIN_VALUE_EDIT_SUCCESS";
export const FETCH_ADMIN_COIN_VALUE_EDIT_FAILURE = "FETCH_ADMIN_COIN_VALUE_EDIT_FAILURE";